interface AddressStatusDotProps {
  address: string | null;
  verified: boolean;
  className?: string;
}

export default function AddressStatusDot({
  address,
  verified,
  className = '',
}: AddressStatusDotProps) {
  const { color, label } = !address
    ? { color: 'bg-gray-400', label: 'Keine Adresse' }
    : verified
      ? { color: 'bg-green-500', label: 'Adresse verifiziert' }
      : { color: 'bg-amber-400', label: 'Adresse nicht verifiziert' };

  return (
    <span
      className={`shrink-0 w-2 h-2 rounded-full ${color} ${className}`}
      title={label}
      aria-label={label}
      role="img"
    />
  );
}
